import moment from 'moment';

export function timestampToDate(timestamp) {
  if (!timestamp) return null;
  return moment(timestamp).format('ll');
}

export function timestampToTime(timestamp) {
  if (!timestamp) return null;
  return moment(timestamp).format('HH:mma');
}

export function timestampToDateAndTime(timestamp) {
  if (!timestamp) return null;
  return moment(timestamp).format('DD/MM/YYYY HH:mma');
}

export function durationInMinutesToHumanReadable(durationInMinutes) {
  if (!durationInMinutes) return '';
  if (typeof durationInMinutes === 'string') return durationInMinutes;
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes - 60 * hours;
  return (
    (hours ? `${hours}hr${hours > 1 ? 's' : ''} ` : '') +
    (minutes ? `${minutes}mins` : '')
  );
}

export function rangeDates(openingDate, closingDate) {
  const dates = [];

  const opening = moment(openingDate)
    .hours(0)
    .minutes(0)
    .seconds(0);

  const closing = moment(closingDate)
    .hours(0)
    .minutes(0)
    .seconds(0);

  while (opening.diff(closing) < 0) {
    dates.push(opening.format('YYYY-MM-DD'));
    opening.add(1, 'day');
  }

  return dates;
}
